import Vue from 'vue'
// export default new Vue()
const Bus = new Vue()
export default Bus


// WEBPACK FOOTER //
// ./src/utils/bus.js